import { render, staticRenderFns } from "./ProfileInfo.vue?vue&type=template&id=639b9b3e&scoped=true&"
import script from "./ProfileInfo.vue?vue&type=script&lang=ts&"
export * from "./ProfileInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileInfo.vue?vue&type=style&index=0&id=639b9b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b9b3e",
  null
  
)

export default component.exports